export enum CueType {
  CueIn = 'CueIn',
  CueOut = 'CueOut'
}
